module.exports = __webpack_public_path__ + "img/sky_01.1bf4627e.jpg";